<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <!-- <list
      row-key="RecordId"
      ref="list"
      unit="实时数据"
      :page="page"
      :show-checkbox="multiple"
      :show-query="false"
      :query-params="params"
      :get-data-func="api.list"
       @check-change="checkChange"
        :reset-data-func="resetData"
      v-if="trendShow"
      urlHash="facility/equipment/realtimedata"
      :temp-params="tempParams"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list> -->
    <el-form :class="{ 'warning-form': data.WarnStatus === 1 }">
      <el-row>
        <el-col :span="12">
          <el-form-item label="温度1" prop="T1">
            {{ data.T1 }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="温度2" prop="T2">
            {{ data.T2 }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="温度3" prop="T3">
            {{ data.T3 }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="温度4" prop="T4">
            {{ data.T4 }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="温度5" prop="T5">
            {{ data.T5 }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="温度6" prop="T6">
            {{ data.T6 }}
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="温度7" prop="T7">
            {{ data.T7 }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="温度8" prop="T8">
            {{ data.T8 }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="温度9" prop="T9">
            {{ data.T9 }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="温度10" prop="T10">
            {{ data.T10 }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="油温" prop="OT">
            {{ data.OT }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template> 
<script>
// import listMixin from "@/mixins/trend/list";
// import list from "@/components/common/trendsTable/list";

export default {
  mixins: [],
  components: {},
  props: {
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      api: require('@/api/equipment/realtimedata').default,
      trendShow: true,
      params: {
        ProductName: '',
        MouldName: ''
      },
      tempParams: {
        //    ProgrammeType: 1
      },
      ids: [],
      data:{}
    }
  },
  methods: {
    getInfo(id) {
      console.log(id, 'get')
      this.api.getLastInfo(id).then(res => {
        this.data = res.Data
      })
    }
  }
}
</script>
<style scoped>
/* .warning-form :deep(.el-form-item__label), */
.warning-form :deep(.el-form-item__content) {
  color: #ff0000 !important;
}
</style>

